import { backendUrl } from "./backendUrl";

const ENQUIRIES_API_URL = backendUrl("/Api/enquiries.php");

export async function createEnquiry(enquiry) {
  const response = await fetch(ENQUIRIES_API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(enquiry),
  });

  let data = null;

  try {
    data = await response.json();
  } catch (error) {
    throw new Error("The enquiry server returned an invalid response.");
  }

  if (!response.ok || !data?.success) {
    throw new Error(data?.message || "The enquiry could not be saved.");
  }

  return data;
}
